// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m_covert_page .mcrt_title{position:relative;padding-left:12px;font-size:20px;font-weight:700;line-height:22px;color:#333;border-left:3px solid #548ef8}.m_covert_page .file2file_cntr{min-height:300px}", ""]);
// Exports
module.exports = exports;
